// 正式环境域名
const productionHost = '.ulearning.cn'

// 通过地址获取域名
const host = location.host
const isDev =
  host.indexOf('192.168') === 0 || host === '127.0.0.1' || host.indexOf('localhost') === 0 
const protocol = isDev ? 'https://' : location.protocol + '//'
const hostDomain = isDev ? '.tongshike.cn' : host.substring(host.indexOf('.'))

const isTest = hostDomain === '.tongshike.cn'

// cookie写入的域名
const hostname = location.hostname
const UMOOC_COOKIE_DOMAIN = isDev
  ? hostname
  : hostname.substring(hostname.indexOf('.'))

const isI18n = false
// 考试
const UTEST_API_HOST = protocol + 'utestapi' + hostDomain
const UTEST_WEB_HOST = protocol + 'utest' + hostDomain


// 手机考试
let UTEST_MOBILE_WEB_HOST = protocol + 'mexam' + hostDomain
// 优学院
const COURSE_API_HOST = protocol + 'courseapi' + hostDomain
// const COURSE_API_HOST = 'http://192.168.8.145:1111'
// UA课件
const UA_API_HOST = protocol + 'api' + hostDomain
// 1.0页面及接口地址
const UMOOC_API_HOST = protocol + 'www' + hostDomain
// 移动端H5
const UMOBILE_WEB_HOST = protocol + 'umobile' + hostDomain
const KNOWLEDGE_GRAPH_WEB_HOST = protocol + 'kg' + hostDomain
const UA_WEB_HOST = protocol + 'ua' + hostDomain
const COURSE_WEB_HOST = protocol + 'courseweb' + hostDomain
const UMOOC_WEB_HOST = protocol + 'umooc' + hostDomain

// 知识图谱
const KG_API_HOST = protocol + 'knowledgeapi' + hostDomain
// 作业
const HOMEWORK_API_HOST = protocol + 'homeworkapi' + hostDomain

// 上传base64编码图片接口
const QINIU_BASE64_URL = 'https://up.qbox.me/putb64/-1'
// 1.0下载地址
const QINIU_DOWNLOAD_HOST = protocol + "download" + productionHost;
// 资源上传和访问
const UPLOAD_SERVER_HOST =  'uobs' + productionHost
const UPLOAD_SERVER_PROTOCOL = protocol.indexOf("https") === 0 ? 'https' : 'http';
const RESOURCE_SERVER_HOST = protocol + 'leicloud' + productionHost
// 静态资源地址
let UMOOC_STATIC_HOST = protocol + 'www' + hostDomain + '/static'
// 文档预览
const DOCS_API_HOST = protocol + 'docs' + productionHost

const ULAB_WEB_HOST = protocol + 'ulab' + hostDomain

//tonglab实验
const TONGLAB_WEB_HOST = isTest ? 'https://tonglab-preview.mybigai.ac.cn' : 'https://tonglab.mybigai.ac.cn'

const WXPCLOGINAPPID = "wx5d5eb33d5f4d5e9c" //pc微信扫码登录
const WXGZHAPPID = "wxd8120ff1adc0eb60" //优学院公众号appid 微信浏览器唤起微信登录等使用
const IS_SELF_UPLOAD = false
let ORG_SITE = location.host.substring(0, location.host.indexOf('.'))
if(location.hostname.indexOf('.tongshike.cn') !== -1) {
  UTEST_MOBILE_WEB_HOST = protocol + 'activityvue' + hostDomain + '/mexam'
  UMOOC_STATIC_HOST = protocol + 'www' + hostDomain + '/static'
}
export default {
  hostDomain,
  UMOOC_COOKIE_DOMAIN,
  API_HOST: COURSE_API_HOST,
  COURSE_API_HOST,
  KG_API_HOST,
  TEST_API_HOST: HOMEWORK_API_HOST,
  UTEST_WEB_HOST,
  UTEST_API_HOST,
  UA_API_HOST,
  QINIU_BASE64_URL,
  RESOURCE_SERVER_HOST,
  RESOURCE_DOWNLOAD_HOST: QINIU_DOWNLOAD_HOST,
  DOCS_HOST: DOCS_API_HOST,  
  UMOBILE_HOST: UMOBILE_WEB_HOST,
  UMOOC_SERVER_HOST: UMOOC_API_HOST,
  WXPCLOGINAPPID,
  WXGZHAPPID,
  ORG_SITE,
  isI18n,
  UPLOAD_SERVER_HOST,
  UPLOAD_SERVER_PROTOCOL,
  KNOWLEDGE_GRAPH_WEB_HOST,
  UA_WEB_HOST,
  COURSE_WEB_HOST,
  IS_SELF_UPLOAD,
  UMOOC_WEB_HOST,
  TONGLAB_WEB_HOST,
  ULAB_WEB_HOST
}
  
  
  